import React, { useState, useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
// lodash
import _ from 'lodash';
// mui
import { Card as MuiCard, Grid as MuiGrid, Box, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
// components
import { withShowable } from '../../_global/lib/withShowable';
import withRouter from '../../../components/hocs/withRouter';
import { CustomCheckbox } from '../../../components/inputs/index';
import CbButton from '../../../components/Buttons/CbButton';
import { QuoteStepLoader } from './QuoteStepLoader';
// actions
import {
  fetchQuoteDetails,
  fetchP250QuotePageDetails,
  actionOnCustomer,
} from '../../../inbox/QuotesService';
import { ProductTypes } from '../../../types';
import { manageAPIError } from '../../../utils';
import { useActor } from '../../../components/hooks/useActor';
import useNotifications from '../../../_lib/notifications/useNotifications';

const CheckBox = withShowable(CustomCheckbox);

export const NameChange = withRouter(({ history }: any) => {
  const notifications = useNotifications();
  // @ts-expect-error TS(2339): Property 'quoteId' does not exist on type '{}'.
  const { quoteId, product } = useParams();
  const classes = useStyles();

  const actor = useActor();

  const [quote, setQuote] = useState({});
  const [onBehalf, setBehalf] = useState(true);
  const [changeTo, setChangeTo] = useState(false);
  const [loading, setLoading] = useState({});
  const [redirect, setRedirect] = useState(false);
  const [invalid, setInvalid] = useState(false);

  const isRenewal = _.get(quote, 'isRenewal');
  const customerStatus = _.get(quote, 'customerStatus');
  const isMigration = _.get(quote, 'isMigration');

  const callQuoteDetails = () => {
    if (product === ProductTypes.p100) {
      fetchQuoteDetails(quoteId).then((response) => {
        if (
          response.data.customerStatus === 'INVALID' ||
          response.data.customerStatus === 'REFERRED'
        ) {
          setInvalid(true);
        }
        setQuote(response.data);
      });
    }

    if (product === ProductTypes.p250) {
      fetchP250QuotePageDetails(quoteId).then((response) => {
        if (
          response.data.customerStatus === 'INVALID' ||
          response.data.customerStatus === 'REFERRED'
        ) {
          setInvalid(true);
        }
        setQuote(response.data);
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    callQuoteDetails();
    setLoading(false);

    // eslint-disable-next-line
  }, []);

  if (loading) {
    return <QuoteStepLoader />;
  }

  const handleCheckBox = (event: any, selected: any) => {
    const { name } = event.target;
    if (name === 'onBehalf') {
      setBehalf(selected);
      setChangeTo(!selected);
    } else if (name === 'changeTo') {
      setChangeTo(selected);
      setBehalf(!selected);
    }
  };

  const handleCustomerChange = () => {
    if (onBehalf) {
      setRedirect(true);
    } else if (changeTo) {
      const payload = {
        quoteId,
        customerFirstName: actor.firstName,
        customerLastName: actor.lastName,
        customerEmail: actor.email,
        customerPhone: actor.phone,
        productType: product,
      };

      actionOnCustomer({}, payload)
        .then(() => {
          notifications.success('Name on quote changed successfully.');

          setQuote([]);
          setLoading(true);

          setTimeout(() => {
            callQuoteDetails();
            setRedirect(true);
            setLoading(false);
          }, 2000);
        })
        .catch((error: any) => {
          const errorMessage = manageAPIError(
            error,
            'There has been an issue making this change. Please try again'
          );

          notifications.error(errorMessage);
        });
    }
  };

  if (_.isEmpty(quote)) {
    return null;
  }

  if (redirect) {
    if (isRenewal || isMigration) {
      if (customerStatus === 'APPROVED') {
        const route =
          product === ProductTypes.p100 ? 'accountDetails' : 'attest';
        return (
          <Redirect
            to={`/customer/quotes/${quoteId}/renewals/${product}/${route}`}
          />
        );
      }

      return (
        <Redirect
          to={`/customer/quotes/${quoteId}/renewals/${product}/approve`}
        />
      );
    }
    if (product === ProductTypes.p100) {
      // @ts-expect-error TS(2339): Property 'initialRequestData' does not exist on ty... Remove this comment to see the full error message
      if (quote.initialRequestData.isEndorsement) {
        return (
          <Redirect
            // @ts-expect-error TS(2339): Property 'policyNumber' does not exist on type '{}... Remove this comment to see the full error message
            to={`/customer/quotes/${quoteId}/endorsement-paymentsummary/${product}/policies/${quote.policyNumber}`}
          />
        );
      }
    }
    return <Redirect to={`/customer/quotes/${quoteId}/approve/${product}`} />;
  }

  if (invalid) {
    setTimeout(() => {
      history.push('/customer/policies');
    }, 2000);
  }

  let buttonText = 'Next';
  // @ts-expect-error TS(2339): Property 'customerFirstName' does not exist on typ... Remove this comment to see the full error message
  if (_.isUndefined(quote.customerFirstName) || changeTo) {
    buttonText = 'Confirm Change';
  }

  return (
    <section>
      <MuiCard>
        <Box pl={3} pr={3} pb={3}>
          <h1 className={classes.headings}>
            {/* @ts-expect-error TS(2339): Property 'customerFirstName' does not exist on typ... Remove this comment to see the full error message */}
            {_.isUndefined(quote.customerFirstName)
              ? 'No Name found on Quote'
              : // @ts-expect-error TS(2339): Property 'customerFirstName' does not exist on typ... Remove this comment to see the full error message
                `Name on the Quote is ${quote.customerFirstName} ${quote.customerLastName}`}
          </h1>
          <MuiGrid container direction="column">
            <MuiGrid item md={5}>
              <Divider className={classes.divider} />
              <CheckBox
                name="onBehalf"
                label={
                  <span style={{ fontSize: '1.33rem' }}>
                    Sign on behalf of
                    {/* @ts-expect-error TS(2339): Property 'customerFirstName' does not exist on typ... Remove this comment to see the full error message */}
                    <strong>{`${quote.customerFirstName} ${quote.customerLastName} (${quote.customerEmail})`}</strong>
                  </span>
                }
                checked={onBehalf}
                onChange={handleCheckBox}
                // @ts-expect-error TS(2339): Property 'customerFirstName' does not exist on typ... Remove this comment to see the full error message
                show={!_.isUndefined(quote.customerFirstName)}
              />
            </MuiGrid>
            <MuiGrid item md={5}>
              <CustomCheckbox
                name="changeTo"
                label={
                  <span style={{ fontSize: '1.33rem' }}>
                    Change to{' '}
                    <strong>{`${actor.fullName} (${actor.email})`}</strong>
                  </span>
                }
                checked={
                  // @ts-expect-error TS(2339): Property 'customerFirstName' does not exist on typ... Remove this comment to see the full error message
                  _.isUndefined(quote.customerFirstName) ? true : changeTo
                }
                onChange={handleCheckBox}
              />
              <Divider className={classes.divider} />
            </MuiGrid>
            <MuiGrid item md={5}>
              <Box display="flex" justifyContent="center">
                <CbButton
                  styleName="cancel"
                  onClick={() => history.push('/customer/policies')}
                  buttonText="Cancel"
                />
                <CbButton styleName="primary" onClick={handleCustomerChange}>
                  {buttonText}
                </CbButton>
              </Box>
            </MuiGrid>
          </MuiGrid>
        </Box>
      </MuiCard>
    </section>
  );
});

const useStyles = makeStyles(({ config, palette }) => ({
  divider: {
    margin: '2rem 0',
  },

  headings: {
    margin: 0,
    marginTop: '2rem',
    fontSize: config.textSizes.canon,
    lineHeight: 1,
    textAlign: 'left',
    color: `${palette.primary.contrastText} !important`,
    fontWeight: config.weights.bold,
  },
}));
